import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getCurrencyList } from "../../../services/Settings/settings"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const DynamicDropdown = ({ control, name, onSelectChange, disabled, ...props }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [currencyData, setCurrencyData] = useState([])

  const loadOptions = () => {
    const data = props?.arr
    setIsLoading(false)
    const currency = data?.map(dta => {
      return {
        label: dta && ucfirst(dta),
        value: dta,
        ...dta,
      }
    })

    setCurrencyData(currency)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={currencyData}
              // placeholder={props?.placeholder}
              placeholder={
              <div className="css-placeholder">
                {props?.placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              isDisabled={disabled}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(".modal")}
            />
          )
        }}
      />
    </div>
  )
}

export default DynamicDropdown
